import { render, staticRenderFns } from "./AddressForm.vue?vue&type=template&id=15b67d2b&scoped=true"
import script from "./AddressForm.vue?vue&type=script&lang=js"
export * from "./AddressForm.vue?vue&type=script&lang=js"
import style0 from "./AddressForm.vue?vue&type=style&index=0&id=15b67d2b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15b67d2b",
  null
  
)

export default component.exports